<template>
  <DropdownMenu v-if="conditions.length > 0">
    <template v-slot:activator>
      <Button
        round
        flat
        icon="save_alt"
        color="standard"
        :loading="loading"
        margin
        :tooltip="loading ? $t('Exporting...') : $t('Export')"
        @click="handleClick"
      />
    </template>

    <template v-slot:content v-if="conditions.length > 1">
      <List style="white-space: nowrap" v-for="(item, i) in conditions" :key="i">
        <Item clickable @click="handleClickMenu(item)">
          <ItemSection avatar side v-if="item.icon">
            <Icon :name="item.icon" />
          </ItemSection>
          <ItemSection>
            {{ item.label }}
          </ItemSection>
        </Item>
      </List>
    </template>
  </DropdownMenu>
</template>

<script>
import Button from '../Button';
import Icon from '../Icon';
import DropdownMenu from '../DropdownMenu';
import List from '../List';
import Item from '../Item';
import ItemSection from '../ItemSection';

export default {
  name: 'ExportButton',
  components: { Button, Icon, DropdownMenu, List, Item, ItemSection },
  props: {
    conditions: { type: Array, required: true },
    loading: { type: Boolean, default: false },
  },
  methods: {
    handleClick() {
      if (this.conditions.length !== 1) return false;

      this.$emit('click', this.conditions[0]);
    },
    handleClickMenu(condition) {
      this.$emit('click', condition);
    },
  },
};
</script>

<style lang="scss" scoped>
.q-item__section--avatar {
  min-width: 0;
}
</style>
